import * as Styled from './Field.styles';
import React from 'react';
export const Field = ({ dataCy, ...props }) => {
    return React.createElement(Styled.Field, { ...props, "data-cy": dataCy });
};
